const initialState = {
  height: 0,
  width: 0
};

export const setWindowSize = (width, height) => {
  return {
    type: 'WINDOW_RESIZE',
    width,
    height
  };
};

export const browserReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'WINDOW_RESIZE': {
      return { height: action.height, width: action.width };
    }
    default:
      return state;
  }
};

export default browserReducer;



// WEBPACK FOOTER //
// ./src/common/jsx/layout/BrowserProvider/ducks.js